export default "__VITE_ASSET__9d80abad__"